<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    :type="modalType"
    class="ConfirmDelete"
    :title="params.action + ' confirmation'"
    :submit-name="params.action"
    confirmation
    @submit="onConfirmDelete"
  >
    <p
      v-if="params.prompt"
      class="Prompt text-gray-700"
      v-html="params.prompt"
    />
    <template v-if="extraSecurity">
      <lm-checkbox v-model="checked" :label="checkboxText" />
      <transition name="fade">
        <span v-show="checkError" class="block mt-2 text-xs text-error">{{
          checkError
        }}</span>
      </transition>
      <div class="flex items-center mt-5 px-2 py-4 border">
        <lm-icon icon="warning" class="text-error mr-3" />
        <p class="m-0 text-gray-700">
          Please note: this process cannot be undone.
        </p>
      </div>
    </template>
  </form-modal>
</template>

<script>
import LmCheckbox from '@/components/form/LmCheckbox'
import LmIcon from '@/components/ui/LmIcon'
import EventHub from '@/lib/eventHub'
import {Events, Modal, ModalType} from '@/lib/definitions'
import FormModal from '@/components/modals/FormModal'

export default {
  name: 'ConfirmDelete',
  components: {LmCheckbox, LmIcon, FormModal},
  data() {
    return {
      modalName: Modal.CONFIRM_DELETE,
      modalType: ModalType.DELETE_CONFIRMATION,
      checked: false,
      checkError: '',
      params: {
        action: 'Delete',
        entity: null, // String
        prompt: null // String
      },
      callback: null, // Function
      extraSecurity: null, // Boolean
      callbackArg: null
    }
  },
  computed: {
    checkboxText() {
      return `Permanently delete this ${this.params.entity}`
    }
  },
  watch: {
    checked(b) {
      if (b) this.checkError = ''
    }
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    EventHub.on(Events.OPEN_CONFIRM, this.initModal)
  },
  destroyed() {
    EventHub.removeListener(Events.OPEN_CONFIRM, this.initModal)
  },
  methods: {
    initModal(params, callback, extraSecurity = false, ...callbackArg) {
      this.reset() // not onClose for aesthetics
      if (!params.action) params.action = 'Delete'
      this.params = params
      this.callback = callback
      this.extraSecurity = extraSecurity
      this.callbackArg = callbackArg
      this.modalRef.open()
    },
    onConfirmDelete() {
      if (!this.extraSecurity || (this.extraSecurity && this.checked)) {
        if (this.callback) this.callback(...this.callbackArg)
        this.modalRef.submitSuccess()
      } else {
        this.checkError = `* Check this if you really want to delete this ${this.params.entity}.`
        this.modalRef.submitFails()
      }
    },
    reset() {
      this.checked = false
      this.checkError = ''
      this.params = {
        entity: null,
        prompt: null
      }
      this.callback = null
      this.extraSecurity = null
      this.callbackArg = null
    }
  }
}
</script>

<style>
.ConfirmDelete {
  .Prompt {
    ul {
      margin-top: 10px;
      padding-left: 20px;
      li {
        list-style-type: disc;
      }
    }
    .u-highlight {
      color: theme('colors.black');
    }
  }
}
</style>
